import { useEffect, useState } from "react";
import Hero from "../components/sections/Hero";
import Education from "../components/sections/Education";
import Bento from "../components/sections/Bento";
import Projects from "../components/sections/Projects";
import Experience from "../components/sections/Experience";
import Services from "../components/sections/Services";
import Skills from "../components/sections/Skills";
import Footer from "../components/Footer";
import HorizontalIntro, { EXIT_OVERLAP_VH } from "../components/ui/HorizontalIntro";

// Sideways intro only on large screens with motion allowed; everyone else scrolls normally.
const QUERY = "(min-width: 1200px) and (min-height: 700px) and (prefers-reduced-motion: no-preference)";
const useHorizontalIntro = () => {
  const [on, setOn] = useState(() => window.matchMedia(QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const update = () => setOn(mq.matches);
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);
  return on;
};

const Container = ({ children, className = "" }) => (
  <div className={`relative flex justify-center items-center flex-col sm:px-10 px-5 ${className}`}>
    <div className="max-w-7xl w-full mx-auto">{children}</div>
  </div>
);

const Home = ({ navigate }) => {
  const horizontal = useHorizontalIntro();

  return (
    <>
      {horizontal ? (
        <HorizontalIntro
          panels={[
            {
              key: "hero",
              className: "flex items-center",
              content: (
                <Container className="w-full pt-28">
                  <Hero />
                </Container>
              ),
            },
            {
              key: "profile",
              className: "pt-24 pb-10 px-16",
              content: <Bento layout="screen" />,
            },
          ]}
        />
      ) : (
        <>
          <main className="relative overflow-hidden pt-28">
            <Container>
              <div className="lg:pb-20">
                <Hero />
              </div>
            </Container>
          </main>
          <Container>
            <Bento />
          </Container>
        </>
      )}

      {/* On the horizontal layout, the rest of the page is a sheet that slides up over the pinned intro. */}
      <div
        className={
          horizontal
            ? "relative z-10 bg-primary rounded-t-[2.5rem] border-t border-ink/10 shadow-[0_-30px_80px_rgb(0_0_0/0.18)]"
            : "relative"
        }
        style={horizontal ? { marginTop: `-${EXIT_OVERLAP_VH}vh` } : undefined}
      >
        {horizontal && <div className="mx-auto mt-4 h-1.5 w-14 rounded-full bg-ink/15" aria-hidden="true" />}
        <Container>
          <Projects />
          <Experience />
          <Education />
          <Services />
          <Skills />
          <Footer navigate={navigate} />
        </Container>
      </div>
    </>
  );
};

export default Home;
